import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sun } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PageHead } from '../components/PageHead';
import './CollectionPage.css';

export const SolairesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="collection-page">
      <PageHead
        title="Espace Solaire – Lunetterie du Russey | Maui Jim, Julbo, Banana Moon"
        description="Lunettes solaires adaptées à l'altitude du Haut-Doubs. Verres polarisés Maui Jim, sport Julbo, collection féminine Banana Moon. Lunetterie du Russey (25210)."
        image="/banner-solaires.jpg"
      />
      <div className="collection-page-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="back-button"
        >
          <ArrowLeft size={20} />
          Retour
        </Button>
      </div>

      <div className="collection-page-container">
        <div className="collection-banner">
          <img src="/banner-solaires.jpg" alt="Espace lunettes solaires – protection UV adaptée à l'altitude du Haut-Doubs, Lunetterie du Russey" />
          <div className="collection-banner-overlay">
            <div className="collection-hero-icon">
              <Sun size={48} />
            </div>
            <h1 className="collection-hero-title">Espace Solaire</h1>
            <p className="collection-hero-intro">
              Le climat rude du Haut-Doubs offre parfois de belles journées ensoleillées. 
              En altitude, une bonne protection solaire est importante. C'est pourquoi la 
              Lunetterie du Russey met en avant 3 marques adaptées à sa région.
            </p>
          </div>
        </div>

        <div className="brands-content">
          {/* Maui Jim */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Maui Jim</h2>
                <p className="brand-description">
                  Inspirés du mode de vie hawaïen, les verres polarisés premium sont tout à 
                  fait cohérents avec les besoins visuels de la montagne. Ses verres ultra 
                  transparents et reposants sont plébiscités par les conducteurs, les pêcheurs, 
                  les skieurs et les amateurs de plein air. Les montures durables et esthétiques 
                  sauront vous séduire.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/maui-jim.webp" alt="Lunettes solaires Maui Jim – verres polarisés premium pour ski, montagne et plein air, Haut-Doubs" />
              </div>
            </div>
          </div>

          {/* Julbo */}
          <div className="brand-section">
            <div className="brand-content-wrapper reverse">
              <div className="brand-text">
                <h2 className="brand-title">Julbo</h2>
                <p className="brand-description">
                  On ne présente plus ce fabricant Jurassien spécialiste de la lunette de sport. 
                  Adaptables ou non à la vue, les verres Reactiv sont faits pour explorer nos 
                  grands espaces !
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/julbo.png" alt="Lunettes solaires Julbo – spécialiste jurassien sport et montagne, verres Reactiv adaptables à la vue" />
              </div>
            </div>
          </div>

          {/* Banana Moon */}
          <div className="brand-section">
            <div className="brand-content-wrapper">
              <div className="brand-text">
                <h2 className="brand-title">Banana Moon</h2>
                <p className="brand-description">
                  Parfait rapport qualité-prix pour des solaires durables et fonctionnelles. 
                  L'esthétique féminine et colorée de la collection textile est fidèlement 
                  reproduite sur les lunettes de soleil.
                </p>
              </div>
              <div className="brand-image-large">
                <img src="/banana-moon.png" alt="Lunettes solaires Banana Moon – collection féminine colorée, rapport qualité-prix" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
